import AuthService from "service/Auth";
import TokenService from "service/Token";

export const getTenant = () => {
  const isAuthenticated = !!TokenService.getIsAuthenticated();

  return isAuthenticated ? AuthService.getDataAuth().tenant : "";
};
